export default "/images/GrowNew_Root.webp?762333861ac4cf41266299ac05800c9e";